export const APP_LANGUAGE = "en-US";
